export default __webpack_public_path__ + "static/media/Awareness.2e4107af.svg";